module.exports = __webpack_public_path__ + "a26360ba8db4e033.svg";